/* PLAKTON · pk-search.js — buscador en ventana central */
(function () {
  'use strict';
  var box = document.getElementById('PkSearch');
  if (!box || window.PKSearch) return;
  /* Se cuelga directamente del body: si queda dentro de un contenedor con transform/filtro,
     el fondo oscuro no cubre la pantalla y el header queda por encima */
  if (box.parentNode !== document.body) document.body.appendChild(box);
  var S = window.pkSearchStrings || {};
  var input = box.querySelector('[data-pk-search-input]');
  var idle = box.querySelector('[data-pk-search-idle]');
  var out = box.querySelector('[data-pk-search-results]');
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  if (root.slice(-1) !== '/') root += '/';
  var timer = null, ctrl = null, lastFocus = null;
  var fmt;
  try { fmt = new Intl.NumberFormat(S.locale || document.documentElement.lang || 'es', { style: 'currency', currency: S.currency || 'EUR' }); } catch (e) { fmt = { format: function (n) { return n + ' €'; } }; }
  function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;'); }
  function money(v) { var n = parseFloat(v); return isNaN(n) ? '' : fmt.format(n); }
  function img(u, w) { if (!u) return ''; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }

  function open(q) {
    lastFocus = document.activeElement;
    box.hidden = false;
    document.documentElement.classList.add('pk-search-lock');
    requestAnimationFrame(function () { box.classList.add('is-open'); input.focus(); if (q) { input.value = q; run(); } });
  }
  function close() {
    box.classList.remove('is-open');
    document.documentElement.classList.remove('pk-search-lock');
    setTimeout(function () { box.hidden = true; }, 260);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  function render(q, data) {
    var r = (data && data.resources && data.resources.results) || {};
    var prods = r.products || [], cols = r.collections || [], qs = r.queries || [];
    if (!prods.length && !cols.length) {
      out.innerHTML = '<p class="pk-search__empty">' + esc((S.none || '').replace('{{ q }}', q)) + '</p>';
      return;
    }
    var h = '';
    if (qs.length) {
      h += '<div class="pk-search__sugs">' + qs.slice(0, 4).map(function (s) { return '<a href="' + esc(s.url) + '">' + (s.styled_text || esc(s.text)) + '</a>'; }).join('') + '</div>';
    }
    if (prods.length) {
      h += '<p class="pk-search__label">' + esc(S.products) + '</p><ul class="pk-search__prods" role="list">';
      prods.slice(0, 6).forEach(function (p) {
        var cmp = parseFloat(p.compare_at_price_max || 0), pr = parseFloat(p.price || 0);
        h += '<li><a class="pk-search__prod" href="' + esc(p.url) + '">' +
          '<span class="pk-search__thumb">' + (p.featured_image && p.featured_image.url ? '<img src="' + esc(img(p.featured_image.url, 200)) + '" alt="" loading="lazy" width="100" height="100">' : '') + '</span>' +
          '<span class="pk-search__meta"><span class="pk-search__name">' + esc(p.title) + '</span>' +
          '<span class="pk-search__price' + (cmp > pr ? ' is-sale' : '') + '">' + (cmp > pr ? '<s>' + money(cmp) + '</s> ' : '') + money(pr) + '</span></span></a></li>';
      });
      h += '</ul>';
    }
    if (cols.length) {
      h += '<p class="pk-search__label">' + esc(S.collections) + '</p><div class="pk-search__chips is-cols">' +
        cols.slice(0, 4).map(function (c) { return '<a href="' + esc(c.url) + '">' + esc(c.title) + '</a>'; }).join('') + '</div>';
    }
    h += '<a class="pk-search__all" href="' + esc(S.searchUrl || root + 'search') + '?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last">' + esc(S.view_all) + ' «' + esc(q) + '» <span aria-hidden="true">→</span></a>';
    out.innerHTML = h;
  }

  function run() {
    var q = input.value.trim();
    clearTimeout(timer);
    if (q.length < 2) { out.hidden = true; idle.hidden = false; return; }
    timer = setTimeout(function () {
      if (ctrl) ctrl.abort();
      ctrl = 'AbortController' in window ? new AbortController() : null;
      idle.hidden = true; out.hidden = false;
      out.innerHTML = '<p class="pk-search__empty is-loading">' + esc(S.searching) + '</p>';
      var url = root + 'search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection,query&resources[limit]=6&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,vendor,tag';
      fetch(url, { signal: ctrl ? ctrl.signal : undefined, headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (d) { render(q, d); })
        .catch(function (e) { if (e && e.name === 'AbortError') return; out.innerHTML = '<p class="pk-search__empty">' + esc((S.none || '').replace('{{ q }}', q)) + '</p>'; });
    }, 180);
  }

  input.addEventListener('input', run);
  /* Clic (o toque) fuera de la ventana: se cierra */
  var TRIGGERS = '.header__icon--search, [data-search-mobile], .header__search summary, a[href$="/search"].header__icon';
  document.addEventListener('pointerdown', function (e) {
    if (box.hidden || !box.classList.contains('is-open')) return;
    if (e.target.closest('.pk-search__box') || e.target.closest(TRIGGERS)) return;
    close();
  }, true);
  box.addEventListener('click', function (e) {
    if (e.target.closest('[data-pk-search-close]')) { e.preventDefault(); close(); return; }
    var t = e.target.closest('[data-pk-term]');
    if (t) { e.preventDefault(); input.value = t.getAttribute('data-pk-term'); run(); input.focus(); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !box.hidden) { close(); return; }
    if ((e.metaKey || e.ctrlKey) && (e.key === 'k' || e.key === 'K')) { e.preventDefault(); box.hidden ? open() : close(); }
    if (e.key === 'Tab' && !box.hidden) {
      var f = box.querySelectorAll('input:not([type=hidden]), a[href], button');
      var vis = Array.prototype.filter.call(f, function (el) { return el.offsetParent !== null; });
      if (!vis.length) return;
      if (e.shiftKey && document.activeElement === vis[0]) { e.preventDefault(); vis[vis.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === vis[vis.length - 1]) { e.preventDefault(); vis[0].focus(); }
    }
  });
  /* Sustituye los botones de búsqueda de Ella (escritorio y móvil) */
  document.addEventListener('click', function (e) {
    var trg = e.target.closest(TRIGGERS);
    if (!trg || box.contains(trg)) return;
    e.preventDefault(); e.stopPropagation();
    var d = trg.closest('details'); if (d) d.removeAttribute('open');
    if (!box.hidden && box.classList.contains('is-open')) { close(); return; }
    open();
  }, true);

  window.PKSearch = { open: open, close: close };
})();
